import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import styled from '@emotion/styled'
import './loader.css'

export const LoaderAnimation: FunctionComponent<React.HTMLAttributes<HTMLDivElement>> = props => {
  const { className, ...rest } = props

  return (
    <div className={classnames('lds-spinner', className)} {...rest}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

const LoaderWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LoaderOverlay: FunctionComponent = () => (
  <LoaderWrapper data-test-id="LoaderOverlay">
    <LoaderAnimation />
  </LoaderWrapper>
)
